import { Route } from "@angular/router";
import { ContactFormRouting } from "./contact-form/contact-form-routing";
import { ContactUsComponent } from "./contact-us.component";

export const ContactUsRouting: Route = {
  path: "contact-us",
  component: ContactUsComponent,
  children: [
    ContactFormRouting,
    { path: '', redirectTo: 'contact-form', pathMatch: 'full' },
  ],
  data: {
    breadcrumb: "Nous contacter"
  }
};
